// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"50":"2d6a5d10","126":"57c7d276","366":"d0d92b65","372":"d53a3943","530":"5ad5b5c2","612":"7556148c","782":"799825a2","886":"ab89db0e"}[chunkId] + ".chunk.css";
};